const Announcement = () => {
    return (
        <div className="bg-teal-500 text-white h-10 flex justify-center items-center">
            Greatest deal of your lifetime !!!
        </div>
    )
}

export default Announcement;